/* eslint-disable max-len */
import {
    Container, Grid, Typography, Divider,
} from '@mui/material';
import {
    WhatsApp,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import config from '../../config.client';
import Anchor from '../../foundation/Anchor';
import CustomBR from '../../foundation/CustomBR';

export type FooterProps = {
    children: JSX.Element | JSX.Element[]
}

const FooterTopStyled = styled('div')`
    background: linear-gradient(135deg, #10334b 0%, #2d5a87 100%);
    /* background-color: ${props => props.theme.palette.secondary.main}; */
    h3 {
        font-weight: bold;
    }
    a, a:hover {
        opacity: 1;
        text-decoration: none;
    }

`;

const WhatsappButton = styled('div')`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #128C7E; /* Darker green for better contrast */
    color: #FFFFFF; /* White text for high contrast */
    padding: 12px 24px;
    border-radius: 25px;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
    justify-content: flex-start;
    align-items: center;
    display: flex;

    &:hover {
        background: #0D6E5A; /* Slightly darker green on hover */
    }
`;

const Footer = (): JSX.Element => <div>
    <FooterTopStyled>
        <Container>
            <CustomBR times={2} />
            <Grid container spacing={5}>
                {/* <Grid item sm={12} md={6}>
                    <Typography variant="h3" color="#12B05E">קצת עלינו</Typography>
                    <CustomBR />
                    <Typography variant="body1" style={{ color: '#E0E0E0' }}>
                        Mploy הוא לוח דרושים מבוסס AI, שנועד לסייע למחפשי עבודה ולמעסיקים כאחד, תוך יצירת פלטפורמה חדשנית, <b style={{ color: '#12B05E' }}>איכותית</b> המובילה את שוק העבודה בישראל.
                        <CustomBR times={1} />
                        אנו מאגדים משרות עדכניות מאלפי מקורות בארץ, ומנגישים אותן ביעילות <b style={{ color: '#12B05E' }}>באמצעות סוכן AI</b> חכם שמתאים משרות רלוונטיות למועמדים ומאפשר הגשת מועמדות בלחיצת כפתור.
                        <CustomBR times={1} />
                        הפלטפורמה שלנו מציעה התאמות משרות מבוססות בינה מלאכותית עם אחוז התאמה אישי, <b style={{ color: '#12B05E' }}>קבוצות WhatsApp</b> ייעודיות לפי תחום, ואפליקציה מתקדמת שמאפשרת חיפוש ושליחת קורות חיים מכל מקום ובכל זמן.
                    </Typography>
                    <CustomBR />
                    <Anchor blank href="https://www.facebook.com/mploy100/">
                        <Box style={{
                            width: 40, height: 40, background: '#1877f2', borderRadius: 8, justifyContent: 'center', alignItems: 'center', display: 'flex',
                        }}>
                            <svg style={{ width: 20, height: 20, fill: 'white' }} viewBox="0 0 24 24">
                                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                            </svg>
                        </Box>
                    </Anchor>
                </Grid> */}
                <Grid item sm={12} md={6}>
                    <Typography variant="h3" color="#12B05E">סוכן AI בוואטסאפ</Typography>
                    <Typography variant="body1" color="white">
                        <CustomBR />
                        ✨ רוצים למצוא עבודה בקלות? שוחחו עם הסוכן החכם שלנו ישירות בוואטסאפ.
                    </Typography>
                    <Typography variant="body1" color="white">
                        <CustomBR />
                        הסוכן מבין מה אתם מחפשים, ממליץ על משרות מותאמות ועוזר להגיש מועמדות – בלי לפספס הזדמנויות. מחכים לכם! 📱😊
                        <CustomBR times={2} />
                    </Typography>
                    <Grid container>
                        <Grid item sm={12} lg={5}>
                            <Anchor title={`${config.companyName} - סוכן AI בוואטסאפ`}
                                color="#12B05E"
                                blank
                                href="/go/whatsapp-chat">
                                <WhatsappButton>
                                    <><WhatsApp />&nbsp;שוחח עם הסוכן AI</>
                                </WhatsappButton>
                            </Anchor>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <CustomBR times={3} />
        </Container>
        <Divider />
        <Container style={{ padding: '2rem 2rem' }}>
            <Grid container alignItems="center" alignContent="center" justifyContent="space-between">
                <Grid item sm={12} md={12}>
                    <Grid container spacing={4}>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/" text="דף הבית" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/home/privacy" text="מדיניות הגנת הפרטיות" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/home/regulations" text="תנאי שימוש" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/home/contactus" text="צור קשר" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/about/show" text="אודות" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/en/about/show" text="About Us" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/allTags" text="תגיות" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/qsa" text="הרשמה לסוכן חכם" title="הרשמה מהירה לסוכן החכם שלנו" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/blogs" text="הבלוג שלנו" title="הבלוג שלנו" />
                        </Grid>
                        <Grid item>
                            <Anchor color="#94a3b8" href="/user/buyJobs" text="גיוס עובדים" title="הצטרפות כמעסיק וגיוס עובדים" />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </FooterTopStyled>
    {/* <FooterBottomStyled> */}

    {/* </FooterBottomStyled> */}
</div>;

export default Footer;
